<template>
  <div class="flex items-center">
    <div class="flex flex-col justify-center items-center">
      <ClientOnly>
        <span class="font-bold"> Olà {{ alteraNome() }} </span>
      </ClientOnly>
    </div>
    <div class="flex items-center ml-3">
      <ClientOnly>
        <el-dropdown>
          <span class="flex text-sm bg-gray-100 rounded-full hoder:outline-none p-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <g fill="currentColor">
                <circle cx="12" cy="6" r="4" />
                <ellipse cx="12" cy="17" opacity=".5" rx="7" ry="4" />
              </g>
            </svg>
          </span>
          <template #dropdown>
            <el-dropdown-menu
              class="w-[200px] z-50 my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow">
              <el-dropdown-item @click="gotoLink('/perfil')">
                <NuxtIcon name="perfil" class="text-[18px] mr-2" filled="" /> Perfil
              </el-dropdown-item>
              <el-dropdown-item @click="logoffModal = true">
                <NuxtIcon name="exit" class="text-[18px] mr-2" filled="" /> Sair
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </ClientOnly>
    </div>
  </div>

  <el-dialog v-model="logoffModal" title="Logoff" width="300px" align-center>
    <span>Deseja sair?</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="logoffModal = false">Cancelar</el-button>
        <el-button type="primary" @click="gotoLink('sair')"> Sair </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { useUserStore } from "~/stores/usuario_store";
const { user } = useUserStore();
const userStore = useUserStore();

const logoffModal = ref(false);

function userLoginOut() {
  userStore.setLogoff();
}

const alteraNome = () => {
  return user.usuario.titulo.split(" ")[0];
};

const gotoLink = (link) => {
  if (link === "sair") {
    userLoginOut();
    navigateTo("/login");
    return;
  }

  navigateTo(link);
};
</script>

<style lang="scss" scoped></style>
